import React from 'react';
import Loader from 'react-loader-spinner';
import { withAuthorization } from '../session';
import { faNewspaper, faFileAlt, faGavel, faChartBar } from '@fortawesome/free-solid-svg-icons';
import { faComments } from '@fortawesome/free-solid-svg-icons';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import HomeItem from './HomeItem';

const INITIAL_STATE = {
  loading: false,
  newsCount: 0,
  messageCount: 0,
  offerCount: 0,
  legislationCount: 0,
  institutionalCount: 0,
  juntaCount: 0
};

class HomePage extends React.Component {

  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  componentDidMount() {
    this.setState({
      loading: true
    });
    this.listenCount();
  }

  componentWillUnmount() {
    this.props.firebase.count().off();
  }

  listenCount = () => {
    this.props.firebase.count().off();

    this.props.firebase.count().on('value', (snapshot) => {
      const countObject = snapshot.val();
      console.log(countObject);
      // let list = [];
      // if (messageObject) {
      //   list = Object.keys(messageObject).map(key => ({
      //     ...messageObject[key],
      //     uid: key,
      //   }));
      // }
      this.setState({
        loading: false,
        ...countObject
      });
    });
  }

  render() {

    const { loading, newsCount, messageCount, offerCount, legislationCount, institutionalCount, juntaCount } = this.state;

    return (
      <div>

        <h2>Panel Principal</h2>
        <hr />

        {(!loading) ?
          <div className="row">

            <HomeItem title={newsCount !== 1 ? "Noticias" : "Noticia"}
              count={newsCount}
              bgColor="bg-primary"
              icon={faNewspaper}
              link='/news'
            />

            <HomeItem title={messageCount !== 1 ? "Mensajes" : "Mensaje"}
              count={messageCount}
              bgColor="bg-success"
              icon={faComments}
              link='/messages'
            />

            <HomeItem title={offerCount !== 1 ? "Comisiónes de ofrecimiento" : "Comisión de ofrecimiento"}
              count={offerCount}
              bgColor="bg-warning"
              icon={faBriefcase}
              link='/offers'
            />

            <HomeItem title={legislationCount !== 1 ? "Legislaciones" : "Legislación"}
              count={legislationCount}
              bgColor="bg-danger"
              icon={faGavel}
              link='/legislation'
            />

            <HomeItem title={institutionalCount !== 1 ? "Instucionales" : "Institucional"}
              count={institutionalCount}
              bgColor="bg-info"
              icon={faFileAlt}
              link='/institutional'
            />

            <HomeItem title={juntaCount !== 1 ? "Juntas de clasificación" : "Junta de clasificación"}
              count={juntaCount}
              bgColor="bg-secondary"
              icon={faChartBar}
              link='/junta'
            />


          </div>
          :
          <div className="nav justify-content-center">
            <Loader className="mt-4"
              type="ThreeDots"
              color="#263238"
              height={60}
              width={60}
              timeout={0} />
          </div>
        }



      </div>
    );
  }
}

const condition = authUser => !!authUser;
export default withAuthorization(condition)(HomePage);